import React, { Component } from 'react';
import { connect } from 'react-redux';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import WeatherIcon from "../weatherIcon";
import './style.scss';

class Forecast extends Component {
    contentList = [];
    state = {
        activeKey: Object.keys(this.contentList)[0]
    };

    tabHeaderTemplate = (date) => {
        let formatDate = parseInt(date) + new Date().getTimezoneOffset() * 60;
        console.log(date);
        console.log(new Date(formatDate).getDate());
        return (
            [
                <div className="text-center" key='weekday'>{new Date(formatDate).toLocaleString('ru-Ru', {weekday: 'short'})}</div>,
                <div className="text-center" key='day'>{new Date(formatDate).getDate()}</div>,
                <div className="text-center" key='month'>{new Date(formatDate).toLocaleString('ru-Ru', {month: 'long'})}</div>
            ]
        );
    };
    createContentList(data) {
        let currentTab;
        this.contentList = [];
        data.list.reduce((prev, current) => {
            let currentItem = current.dt * 1000,
                formatDate = new Date(currentItem);

            if (!prev || (prev.getUTCDate() !== formatDate.getUTCDate())) {

                currentTab = currentItem;
                this.contentList[currentTab] = [];
            }
            this.contentList[currentTab].push(current);
            return formatDate;
        }, null);
    }
    render () {
        let { data } = this.props;
        if (!data) { return <div>loading...</div>}
        this.createContentList(data);
        return (
            <Tabs
                id="controlled-tab"
                activeKey={this.state.activeKey}
                onSelect={key => this.setState({ key })}
            >
                {
                    Object.keys(this.contentList).map(item => {
                        return (
                            <Tab eventKey={item} key={item} title={this.tabHeaderTemplate(item)}>
                                <Table hover className='border'>
                                    <thead>
                                        <tr>
                                            <th>Время</th>
                                            <th>Температура</th>
                                            <th>Осадки</th>
                                            <th>Влажность</th>
                                            <th>Облачность</th>
                                            <th>Ветер</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.contentList[item].map((_item) => {
                                                return (
                                                    <tr key={_item.dt}>
                                                        <th className="time">{new Date(_item.dt * 1000).getUTCHours()}:00</th>
                                                        <th>{Math.round(_item.main.temp)}&deg;C</th>
                                                        <th>
                                                            <WeatherIcon imgData={_item.weather[0]}/>
                                                        </th>
                                                        <th>{_item.main.humidity}%</th>
                                                        <th>{_item.clouds.all}%</th>
                                                        <th>
                                                            <span className="arrow-wind" style={{transform: 'rotate(' + Math.ceil(_item.wind.deg) + 'deg)', display: 'inline-block'}}>&#8595;</span>
                                                            {Math.round(_item.wind.speed)} м/с
                                                        </th>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </Tab>
                        )
                    })
                }
            </Tabs>

        )
    }
}

export default connect(
    state => ({
        data: state.forecastWeatherData
    }),
    dispatch => ({})
)(Forecast);